import { colors } from '@ardoq/design-tokens';
import { IconName } from '@ardoq/icons';
import { SelectOption } from '@ardoq/select';

export const CONFIDENTIAL_FIELD_WARNING_MESSAGE =
  'This confidential field will be visible to everyone who can access this report.';

export const toConfidentialFieldSelectOption = <T>(
  option: SelectOption<T>,
  isSelected: boolean = false
): SelectOption<T> => {
  const warningMessageAs = isSelected ? 'popoverContent' : 'description';
  return {
    ...option,
    [warningMessageAs]: CONFIDENTIAL_FIELD_WARNING_MESSAGE,
    rightIcon: {
      name: IconName.CONTROL,
      color: colors.iconWarning,
    },
    rightIconName: undefined,
  };
};
